export default "__VITE_ASSET__334a77b3__"